/* global React, ConfirmModal, t, toast */
(function () {
  // Shared "delete ticket" flow for the detail header and the list rows. The backend
  // soft-deletes, but the customer only ever sees a plain delete.
  // Usage: const { requestDelete, deleteDialog, deleteBusy } = useSupportTicketDelete(onDeleted);
  function useSupportTicketDelete(onDeleted) {
    const [pending, setPending] = React.useState(null);
    const [busy, setBusy] = React.useState(false);
    const confirm = async () => {
      setBusy(true);
      try {
        await window.PlummeBackend.archiveSupportTicket(pending.id);
      } catch (requestError) {
        toast(t('support.error.delete'), 'error');
        throw requestError;
      } finally {
        setBusy(false);
      }
      toast(t('support.delete.done'), 'success');
      onDeleted(pending.id);
    };
    const deleteDialog = pending ? <ConfirmModal open onClose={() => setPending(null)} onConfirm={confirm}
      title={t('support.delete.title')} confirmLabel={t('support.delete.confirm')} busy={busy}>
      {t('support.delete.text')}
    </ConfirmModal> : null;
    return { requestDelete: setPending, deleteDialog, deleteBusy: busy };
  }

  window.useSupportTicketDelete = useSupportTicketDelete;
})();
